import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-expanded"]

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileModalDropDown',
  props: {
    childClass: {},
    parentClass: {}
  },
  setup(__props: any) {

const props = __props;
const isNavbarCollapsed = ref(false);

const toggleNavbar = () => {
  isNavbarCollapsed.value = !isNavbarCollapsed.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      onClick: toggleNavbar,
      "aria-controls": "navbarContent",
      "aria-expanded": isNavbarCollapsed.value ? 'false' : 'true',
      "aria-label": "Toggle navigation"
    }, [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
      ])
    ], 8, _hoisted_1),
    _createVNode(_Transition, { duration: 200 }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(_ctx.parentClass),
          onClick: _withModifiers(toggleNavbar, ["self"])
        }, [
          _createVNode(_Transition, { name: "drop-down" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                role: "region",
                id: "navbarContent",
                class: _normalizeClass(props.childClass)
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 2), [
                [_vShow, isNavbarCollapsed.value]
              ])
            ]),
            _: 3
          })
        ], 2), [
          [_vShow, isNavbarCollapsed.value]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})